import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Panel } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
class Pane extends Component {
    render() {
        const { t } = this.props;
        return (React.createElement(Panel, { header: t('SHIPMENT_DETAILS'), defaultExpanded: true },
            this.props.header,
            this.props.body));
    }
}
Pane.propTypes = {
    header: PropTypes.any,
    body: PropTypes.any,
};
export default withTranslation()(Pane);
